// @flow
import { CommonActions } from '@react-navigation/native';
import { call, put, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../api';
import { trackAnalyticsEvent } from '../../lib/analytics';
import I18n from '../../lib/i18n';
import Navigation from '../../lib/navigation';
import Toast from '../../lib/toastService';
import { fetchCustomer } from '../Customer';
import { setLoading } from '../LoadingStatus';
import type { VoucherAddMoneyActionType } from './actions';
import { clearVoucherData, fetchVoucherFailure, fetchVoucherRequest, setVoucher, updateVoucherCode } from './actions';
import WizzeeLog from '../../lib/wizzeeLog';

export function* leaveAddMoneySceneSaga(action: VoucherAddMoneyActionType): Generator<*, *, *> {
  try {
    yield put(clearVoucherData());
    yield put(updateVoucherCode(null));
    yield call(Navigation.dispatch, CommonActions.goBack());
  } catch (error) {
    WizzeeLog.warn('[saga] leaveAddMoneySceneSaga', error);
  }
}

export function* redeemVoucherSaga(action: VoucherAddMoneyActionType): Generator<*, *, *> {
  if (action.type !== 'REDEEM_VOUCHER') return; // for flow
  const { customerOuid, voucherCode } = action.payload;

  yield put(setLoading('redeemVoucher', true));

  try {
    try {
      yield call(trackAnalyticsEvent, 'redeem_voucher');
    } catch (error) {
      WizzeeLog.warn('[saga] redeemVoucherSaga analytics', error);
    }

    yield call([tripica, 'redeemVoucher'], customerOuid, voucherCode, 0);
    yield call(leaveAddMoneySceneSaga);
    yield call(fetchCustomer);
  } catch (error) {
    WizzeeLog.warn('[saga] redeemVoucherSaga', error);
    yield put(clearVoucherData());
    yield call(Toast.showError, I18n.t('error.default'));
  } finally {
    yield put(setLoading('redeemVoucher', false));
  }
}

export function* fetchVoucherSaga(action: VoucherAddMoneyActionType): Generator<*, *, *> {
  if (action.type !== 'FETCH_VOUCHER') return; // for flow

  const { voucherCode } = action.payload;

  yield put(setLoading('fetchVoucher', true));

  try {
    yield put(fetchVoucherRequest());

    const voucher = yield call([tripica, 'voucherDetails'], voucherCode);

    yield put(setVoucher(voucher));
  } catch (error) {
    yield put(fetchVoucherFailure(error));

    const errorMessage = error.status === 404 ? 'voucherInvalid' : 'error.default';
    yield call(Toast.showError, I18n.t(errorMessage));
  } finally {
    yield put(setLoading('fetchVoucher', false));
  }
}

export default function* VoucherSaga(): Generator<*, *, *> {
  yield takeEvery('LEAVE_ADD_MONEY_SCENE', leaveAddMoneySceneSaga);
  yield takeEvery('REDEEM_VOUCHER', redeemVoucherSaga);
  yield takeEvery('FETCH_VOUCHER', fetchVoucherSaga);
}
